/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { createSelector } from 'reselect';

export function toOptions(result) {
  const { status } = result;
  if (status === 'success') {
    return result.data.list.map(l => ({
      label: l.name,
      value: l.name,
    }));
  }
  return [];
}

export const enumsToOptions = (type, state) => {
  const selector = s => s.enums[type];
  return createSelector(
    selector,
    list => toOptions(list),
  )(state);
};




// WEBPACK FOOTER //
// ./src/utils/api/selector.js